import React from "react";
import { Box, Stack, Typography } from "@mui/material";

function MatrixBorderProgressBar({
  paid,
  overdue,
  total,
  paidColor = "limegreen",
  overdueColor = "orangered",
  remainingColor = "lightgrey",
}) {
  const gridSize = 5; // Number of boxes per side of the square
  const totalBoxes = gridSize * 4 - 4; // Total boxes on the perimeter
  const remaining = total - paid - overdue;

  const paidBoxes = Math.round((paid / total) * totalBoxes);
  const overdueBoxes = Math.round((overdue / total) * totalBoxes);
  const remainingBoxes = totalBoxes - paidBoxes - overdueBoxes;

  // Create a matrix with empty content
  const matrix = Array.from({ length: gridSize }, () =>
    Array(gridSize).fill(null)
  );

  // Fill the perimeter with the respective progress colors
  let boxIndex = 0;

  // Top row
  for (let i = 0; i < gridSize; i++) {
    matrix[0][i] =
      boxIndex < paidBoxes
        ? paidColor
        : boxIndex < paidBoxes + overdueBoxes
        ? overdueColor
        : remainingColor;
    boxIndex++;
  }

  // Right column (except first cell)
  for (let i = 1; i < gridSize; i++) {
    matrix[i][gridSize - 1] =
      boxIndex < paidBoxes
        ? paidColor
        : boxIndex < paidBoxes + overdueBoxes
        ? overdueColor
        : remainingColor;
    boxIndex++;
  }

  // Bottom row (except last cell)
  for (let i = gridSize - 2; i >= 0; i--) {
    matrix[gridSize - 1][i] =
      boxIndex < paidBoxes
        ? paidColor
        : boxIndex < paidBoxes + overdueBoxes
        ? overdueColor
        : remainingColor;
    boxIndex++;
  }

  // Left column (except first and last cell)
  for (let i = gridSize - 2; i > 0; i--) {
    matrix[i][0] =
      boxIndex < paidBoxes
        ? paidColor
        : boxIndex < paidBoxes + overdueBoxes
        ? overdueColor
        : remainingColor;
    boxIndex++;
  }

  return (
    <Box
      sx={{
        display: "inline-block",
        position: "relative",
        padding: "8px",
        backgroundColor: "#fff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px", // Rounded corners for the outer box
      }}
    >
      {/* Render the matrix */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: `5px repeat(${gridSize - 2}, 1fr) 5px`,
          gridTemplateRows: `5px repeat(${gridSize - 2}, 1fr) 5px`,
          gap: "0",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
          borderRadius: "8px", // Rounded corners for the grid
          overflow: "hidden", // Ensure the rounded corners are respected
        }}
      >
        {matrix.flat().map((color, index) => (
          <Box
            key={index}
            sx={{
              backgroundColor: color,
              width: "100%",
              height: "100%",
              // borderRadius: "1px", // Slightly rounded corners for each cell
            }}
          />
        ))}
      </Box>

      {/* Main content area */}
      <Stack
        gap={1}
        sx={{
          position: "relative",
          zIndex: 2,
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          borderRadius: "8px",
          direction: { xs: "column", sm: "column", md: "row" },
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: "16px",
            lineHeight: "1.2",
          }}
        >
          {`${paid}/${total} `}
        </Typography>
        <Typography
          sx={{
            color: "#7d7d7d",
            fontSize: "14px",
            textAlign: "center",
          }}
        >
          {" "}
          Paid Installment
        </Typography>
      </Stack>
    </Box>
  );
}

// Example usage
export default MatrixBorderProgressBar;
